<template>
  <div class="home">
    <Home />
    <finePrints v-if="disclaimer" :disclaimer="disclaimer" />
    <PageView v-if="dtm" pageName="vehicles|new|leaf|range-charging|rangecalculator" />
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import Home from "@/components/Home";
import finePrints from "@/components/finePrints";
import PageView from "@/components/shared/DTM/PageView";

export default {
  name: "home",
  components: {
    Home,
    finePrints,
    PageView
  },
  computed: {
    ...mapState({
      disclaimer: state => state.txt.common.disclaimers.home,
      dtm: state => state.dtm
    })
  }
};
</script>
